import { styled as muiStyled, Paper } from '@mui/material'

export const StyledRequestTherapyComponent = muiStyled(Paper)(
  ({ theme }) => `
    width: 100%;
`,
)

export const ConsultsTabTableContainer = muiStyled('div')(
  ({ theme }) => `
    td {
        background: transparent;
    }

    /* Completed sessions are shown in green */
    tr.consults-completed-row td {
        color: #047857;
    }

    /* Bold line separating the completed sessions that appear below it */
    tr.consults-completed-divider td {
        border-top: 3px solid #059669 !important;
    }
`,
)

export const StyledSendPrescriptionDataDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
    width: 100% !important;
    margin: 0px !important;
`,
)
